// Категория: хелперы без побочных эффектов, кроме чтения window.location.origin
// в safeUrl() — оно нужно, чтобы резолвить относительные адреса.

/**
 * Экранирует значение для вставки в разметку.
 * Данные задачи приходят с конвертера и содержат подконтрольные автору ролика поля
 * (title, thumb): в разметку они должны попадать только экранированными.
 * @param value {*}
 * @returns {string}
 */
export function escapeHtml(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

/**
 * Адрес, пригодный для src/href/window.open: только http(s), иначе пустая строка.
 * Относительные адреса резолвятся от origin самого сайта.
 * @param value {*}
 * @returns {string} абсолютный адрес либо '' — проверку он не прошёл
 */
export function safeUrl(value) {
    const raw = String(value ?? '').trim();
    // пустая строка резолвится в origin самого сайта — это не ссылка, а не отсутствие проверки
    if (!raw) {
        return '';
    }

    try {
        const url = new URL(raw, window.location.origin);
        return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
    } catch (e) {
        return '';
    }
}

/**
 * Имя файла для внешнего LocalConverter и атрибута download.
 * Заголовок ролика подконтролен его автору, поэтому режем разделители пути,
 * управляющие символы, bidi-override и длину.
 * @param value {*}
 * @param maxLength {number}
 * @returns {string} непустое имя — при полностью вырезанном исходнике 'video'
 */
export function safeFilename(value, maxLength = 120) {
    const raw = String(value ?? '')
        // eslint-disable-next-line no-control-regex
        .replace(/[\u0000-\u001f\u007f]/g, '')
        // bidi-override: иначе автор ролика визуально подменит расширение
        // в списке загрузок ('gnp.exe' покажется как 'exe.png')
        .replace(/[\u200e\u200f\u202a-\u202e\u2066-\u2069]/g, '')
        .replace(/[\\/:*?"<>|]/g, '_')
        .replace(/\s+/g, ' ')
        .trim();

    const filename = raw || 'video';
    if (filename.length <= maxLength) {
        return filename;
    }

    // Callers pass the complete filename (`title.ext`). Truncating it as one string
    // removed .mp4/.mp3 from long titles, leaving LocalConverter output without a
    // usable extension. Reserve room for a conventional extension and trim only the
    // basename. Unknown or unusually long suffixes retain the old bounded behavior.
    const extensionMatch = filename.match(/(\.[a-z0-9]{1,10})$/i);
    if (!extensionMatch || extensionMatch[1].length >= maxLength) {
        return filename.slice(0, maxLength);
    }

    const extension = extensionMatch[1];
    const basename = filename.slice(0, -extension.length);
    return `${basename.slice(0, maxLength - extension.length).trimEnd()}${extension}`;
}
